import { HANDLE_DEVICE_DATA, RESET } from '../actions';

const initialState = {
    deviceData: [],
    deviceList: [],
    deviceListAPICalled: false,
    selectedDevice: "",
    selectedIMEI: "",
    selectedPowerMeter: "",

    skip: 0,
    limit: 50,
    powerMeterLog: [],
    interval: 4
};

const DeviceData = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_DEVICE_DATA:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default DeviceData;